import styled from 'styled-components';

const SkeletonContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem 1rem;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
  text-align: center;
`;

const SkeletonTitle = styled.div`
  width: 200px;
  height: 32px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card_light} 25%,
    ${({ theme }) => theme.card} 50%,
    ${({ theme }) => theme.card_light} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 8px;
  margin: 0 auto 1rem;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
  text-align: ${({ $isRTL }) => ($isRTL ? 'right' : 'left')};
`;

const SkeletonDesc = styled.div`
  width: 100%;
  max-width: 600px;
  height: 20px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card_light} 25%,
    ${({ theme }) => theme.card} 50%,
    ${({ theme }) => theme.card_light} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 4px;
  margin: 0 auto 3rem;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
  text-align: ${({ $isRTL }) => ($isRTL ? 'right' : 'left')};
`;

const SkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  width: 100%;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
`;

const SkeletonSkill = styled.div`
  width: 100%;
  height: 80px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card_light} 25%,
    ${({ theme }) => theme.card} 50%,
    ${({ theme }) => theme.card_light} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 15px;
  display: flex;
  align-items: center;
  padding: 1rem;
`;

const SkeletonIcon = styled.div`
  width: 32px;
  height: 32px;
  background: linear-gradient(90deg, ${({ theme }) => theme.card} 25%, ${({ theme }) => theme.card_light} 50%, ${({ theme }) => theme.card} 75%);
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 8px;
  margin-${({ $isRTL }) => ($isRTL ? 'left' : 'right')}: 1rem;
`;

const SkeletonText = styled.div`
  flex: 1;
  height: 16px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card_light} 25%,
    ${({ theme }) => theme.card} 50%,
    ${({ theme }) => theme.card_light} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 4px;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
  text-align: ${({ $isRTL }) => ($isRTL ? 'right' : 'left')};
`;

const SkillsSkeleton = ({ $isRTL = false }) => (
  <SkeletonContainer $isRTL={$isRTL}>
    <SkeletonTitle $isRTL={$isRTL} className="skeleton-enhanced" />
    <SkeletonDesc $isRTL={$isRTL} className="skeleton-enhanced" />
    <SkeletonGrid>
      {[...Array(2)].map((_, i) => (
        <SkeletonSkill key={i} className="skeleton-enhanced">
          <SkeletonIcon $isRTL={$isRTL} className="skeleton-enhanced-dark" />
          <SkeletonText $isRTL={$isRTL} className="skeleton-enhanced" />
        </SkeletonSkill>
      ))}
    </SkeletonGrid>
  </SkeletonContainer>
);

export default SkillsSkeleton;
